import React from 'react'
import '../../App.css'

export const Booknow = () => {
  return (
    <h1 className='booknow'>Book now</h1>
  )
}
